import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { DealValuesPage } from "@/components/hubspot/deal-values-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/deal-values/$field",
  loader: async ({ params }) => {
    const res = await fetch(`/api/deal-values/${params.field}`);
    if (!res.ok) throw new Error("Failed to load values");
    const data = await res.json();
    return { values: data.values ?? [], label: data.label ?? "", field: params.field };
  },
  component: DealValuesGuard,
});

function DealValuesGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <DealValuesPage />;
}
